import Vue from 'vue'
import axios from 'axios'

import VModal from 'vue-js-modal'

import Ai from '../vue/ai/Ai.vue';


import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import ArtistProfileController from "../stimulus/artist_profile_controller.js"
// Initialize Stimulus
const application = Application.start()
const context = require.context('../stimulus', true, /\.js$/)
application.load(definitionsFromContext(context))

// Register the controller if needed
application.register("artist-profile", ArtistProfileController)



Vue.prototype.$axios = axios
Vue.use(VModal)

document.addEventListener('DOMContentLoaded', () => {
    let el = document.getElementById('vue-ai')
		Vue.prototype.$axios.defaults.baseURL = '/v3'
	
		Vue.prototype.$axios.defaults.headers.common = {
			'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8'
		}
    if (el != null) {
			const isProd = el.dataset.isProd === "true";
			const props = {
				artists: JSON.parse(el.dataset.artists),
				currentUser: el.dataset.currentUser,
				currentUserAvatar: el.dataset.currentUserAvatar,
				isProd: isProd,
				city: JSON.parse(el.dataset.city),
				country: JSON.parse(el.dataset.country),
				artType: JSON.parse(el.dataset.artType),
				packagePrice: el.dataset.packagePrice
			}
	
			new Vue({
				el: el,
				render: h => h(Ai, { props }),
				components: {
					Ai
				}
			})
			
    }
})